import React, { useEffect, useRef } from "react";

const BTNS = [
  { cmd: "bold", label: "B", title: "Negrita", className: "font-bold" },
  { cmd: "italic", label: "I", title: "Cursiva", className: "italic" },
  { cmd: "underline", label: "U", title: "Subrayado", className: "underline" },
  { cmd: "insertUnorderedList", label: "• Lista", title: "Lista" },
];

/**
 * Editor mínimo contentEditable (sin deps). Emite HTML en onChange.
 */
export default function RichTextEditor({
  value = "",
  onChange,
  placeholder = "Escribe el mensaje…",
  disabled = false,
  className = "",
}) {
  const ref = useRef(null);
  const lastExternal = useRef(value);

  useEffect(() => {
    if (!ref.current) return;
    if (value !== lastExternal.current && value !== ref.current.innerHTML) {
      ref.current.innerHTML = value || "";
      lastExternal.current = value;
    }
  }, [value]);

  function emit() {
    if (!ref.current || !onChange) return;
    const html = ref.current.innerHTML;
    lastExternal.current = html;
    onChange(html);
  }

  function run(cmd) {
    if (disabled) return;
    ref.current?.focus();
    document.execCommand(cmd, false, null);
    emit();
  }

  function onLink() {
    if (disabled) return;
    const url = window.prompt("URL del enlace:");
    if (!url) return;
    ref.current?.focus();
    document.execCommand("createLink", false, url.trim());
    emit();
  }

  return (
    <div
      className={[
        "rounded-xl border border-brand-lavender/25 bg-white overflow-hidden",
        disabled ? "opacity-60" : "",
        className,
      ].join(" ")}
    >
      <div className="flex flex-wrap gap-1 border-b border-brand-lavender/15 px-2 py-1.5 bg-brand-lilac/20">
        {BTNS.map((b) => (
          <button
            key={b.cmd}
            type="button"
            title={b.title}
            disabled={disabled}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => run(b.cmd)}
            className={`px-2.5 py-1 rounded text-sm text-brand-dark hover:bg-white/80 ${b.className || ""}`}
          >
            {b.label}
          </button>
        ))}
        <button
          type="button"
          title="Enlace"
          disabled={disabled}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onLink}
          className="px-2.5 py-1 rounded text-sm text-brand-dark hover:bg-white/80"
        >
          Enlace
        </button>
      </div>
      <div
        ref={ref}
        role="textbox"
        aria-multiline="true"
        aria-label={placeholder}
        contentEditable={!disabled}
        suppressContentEditableWarning
        onInput={emit}
        onBlur={emit}
        data-placeholder={placeholder}
        className="min-h-[140px] max-h-64 overflow-y-auto px-3 py-2.5 text-sm text-brand-dark leading-relaxed outline-none empty:before:content-[attr(data-placeholder)] empty:before:text-brand-gray/70"
      />
    </div>
  );
}
